var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 8,
    fill: "none",
    stroke: "#DAC599",
    viewBox: "0 0 11 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "m2 4 2.334 2L9 2"
  })));
};
export default SvgCheck;